import React, { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { PusherChannel } from "@activecollab/activecollab-react-pusher";
import { List } from "immutable";
import PropTypes from "prop-types";
import ConnectObjectComments from "~/components/comments/component.object_comments.jsx";
import { getProjectById } from "~/store/selectors/selector.projects.jsx";
import { makeObjectPresenceChannelNameSelector } from "~/store/selectors/selector.realTime.jsx";
import { getLoggedUser, makeUserIdListExcludingClientsSelector } from "~/store/selectors/selector.users.jsx";

export const Comments = ({
  parentId,
  parentType,
  commentsCount,
  hiddenFromClients,
  projectId,
  userIds: externalUsers,
  ...rest
}) => {
  const { t } = useTranslation();
  const getUserIdListExcludingClients = useMemo(() => {
    if (projectId && projectId > 0) {
      return makeUserIdListExcludingClientsSelector();
    }
    return () => [];
  }, [projectId]);
  const getObjectPresenceChannelName = useMemo(() => makeObjectPresenceChannelNameSelector(parentType), [parentType]);

  const project = useSelector((state) => getProjectById(state, projectId));
  const loggedUser = useSelector(getLoggedUser);
  const userIdsWithoutClients = useSelector((state) => getUserIdListExcludingClients(state, project?.members));
  const channelName = useSelector((state) => getObjectPresenceChannelName(state, parentId));

  const userIds = useMemo(() => {
    let result = List();
    if (project) {
      if (parentId) {
        result = hiddenFromClients ? userIdsWithoutClients : project.members;
      }
    } else if (Array.isArray(externalUsers)) {
      result = List(externalUsers);
    }

    return result;
  }, [externalUsers, hiddenFromClients, parentId, project, userIdsWithoutClients]);

  return (
    <PusherChannel name={channelName}>
      <ConnectObjectComments
        {...rest}
        totalItems={commentsCount}
        parentType={parentType}
        parentId={parentId}
        projectId={projectId}
        userIds={userIds}
        title={t("Discussion")}
        loggedUserId={loggedUser ? loggedUser.id : 0}
      />
    </PusherChannel>
  );
};

Comments.propTypes = {
  parentId: PropTypes.number,
  parentType: PropTypes.string,
  commentsCount: PropTypes.number,
  hiddenFromClients: PropTypes.bool,
  projectId: PropTypes.number,
  userIds: PropTypes.array,
};

export default Comments;
